<template>
  <img src="loading-bars.svg" class="infinite-loading">
</template>

<script>
export default {
  name: 'InfiniteLoading',
}
</script>

<style scoped lang="scss">

.infinite-loading {
  width: 15px;
  height: 23px;
  position: relative;
}
</style>
